export function isLapsedPaidSubscription(
  billingInfo: { hasStripeCustomer?: boolean; hasActiveSubscription?: boolean } | null | undefined,
  tier: string
): boolean {
  if (!billingInfo?.hasStripeCustomer || billingInfo.hasActiveSubscription) {
    return false
  }
  if (!tier || tier === 'trial') {
    return false
  }
  return tier === 'expired' || tier === 'basic' || tier === 'standard' || tier === 'custom'
}

export function isSubscriptionAccessDenied(
  subscriptionStatus: Record<string, any> | null | undefined
): boolean {
  if (!subscriptionStatus) return false
  const validToStr = subscriptionStatus.subscriptionValidTo as string | undefined
  if (validToStr) {
    const d = new Date(validToStr)
    if (!Number.isNaN(d.getTime())) {
      return Date.now() > d.getTime()
    }
  }
  return subscriptionStatus.subscriptionAccessBlocked === true
}

export function isSubscriptionValidToActive(
  subscriptionValidTo: string | null | undefined
): boolean {
  if (!subscriptionValidTo) return false
  const d = new Date(subscriptionValidTo)
  if (Number.isNaN(d.getTime())) return false
  return Date.now() <= d.getTime()
}

export interface SubscriptionInfo {
  tier: string
  subscriptionValidTo?: string
  isActive: boolean
  daysLeft: number
  display: string
}

export function getSubscriptionInfo(
  subscriptionStatus: Record<string, any> | null | undefined
): SubscriptionInfo {
  const tier = (subscriptionStatus?.tier as string) || ''
  const raw = (subscriptionStatus?.subscriptionValidTo as string) || ''

  if (!raw) {
    return {
      tier,
      subscriptionValidTo: undefined,
      isActive: false,
      daysLeft: 0,
      display: ''
    }
  }

  const end = new Date(raw)
  if (Number.isNaN(end.getTime())) {
    return {
      tier,
      subscriptionValidTo: raw,
      isActive: false,
      daysLeft: 0,
      display: ''
    }
  }

  const now = new Date()
  const diffMs = end.getTime() - now.getTime()
  const daysLeft = Math.ceil(diffMs / (1000 * 60 * 60 * 24))

  const formattedDate = end.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })

  if (diffMs <= 0) {
    return {
      tier,
      subscriptionValidTo: raw,
      isActive: false,
      daysLeft: 0,
      display: `Expired on ${formattedDate}`
    }
  }

  const safeDaysLeft = Math.max(daysLeft, 0)

  return {
    tier,
    subscriptionValidTo: raw,
    isActive: true,
    daysLeft: safeDaysLeft,
    display: `Valid until ${formattedDate} (${safeDaysLeft} days left)`
  }
}
